import { useQuery } from "@tanstack/react-query";
import { getUserDetails } from "@/api/get-user-details";
import { toast } from "sonner";
import { USER_DETAILS_QUERY_KEY } from "@/lib/constants";

export function useUserDetails() {
  return useQuery({
    queryKey: [USER_DETAILS_QUERY_KEY],
    queryFn: async () => {
      const result = await getUserDetails();
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al obtener detalles del usuario", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }
      return result.val;
    },
  });
}
